import React, { useEffect, useRef, useState } from 'react'
import TransactionsBonus from "./components/TransactionsBonus/Transactions";
import {useDispatch, useSelector} from "react-redux";
import transactionsActions from "../../store/transactionsStore/transactionsActions";
import debounce from "../../tools/debounce";
import TransactionsTypes from "../../store/transactionsStore/transactionsTypes";


export default function TransactionsBonusComponent() {
    const dispatch = useDispatch()
    const {info} = useSelector(state => state.branchReducer)
    const profile = useSelector(state => state.profileReducer)
    const {page, data, status} = useSelector(state => state.transactionsReducer)
    const {payment_status} = useSelector(state => state.bonusesModalReducer)
    const {customer} = useSelector(state => state.clientInfoReducer)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [phone, setPhone] = useState('')
    const searchRef = useRef(null);

    const getTransactions = () => {
        dispatch(transactionsActions.getAllBonusTransactions({
            branch_id: info && info.id, page, startDate, endDate, phone,
        }));
    }

    useEffect(() => {
        if (info) {
            debounce(()=>dispatch(transactionsActions.getAllBonusTransactions({
                branch_id: info && info.id, page, startDate, endDate, phone,
            })), 100)
        }
    }, [page, info, endDate, startDate, payment_status])

    useEffect(() => {
        if (info) {
            dispatch({ type: TransactionsTypes.CLEAR_TRANSACTIONS_PAGE })
            debounce(()=>dispatch(transactionsActions.getAllBonusTransactions({
                branch_id: info && info.id, page: 1, startDate, endDate, phone, searchRef,
            })), 1500)
        }
    }, [phone, info])

    const changePageAction = (page) => {
        dispatch(transactionsActions.changePage(page))
    }

    return (
        <TransactionsBonus
            searchRef={searchRef}
            orders={data.orders && data.orders.sort(function (a, b) {
                return b.created_at - a.created_at;
            })}
            getTransactions={getTransactions}
            count={data.count}
            page={page}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            changePageAction={changePageAction}
            customer={customer}
            info={info}
            status={status}
            phone={phone}
            setPhone={setPhone}
        />
    )
}
